import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { Person, PersonOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import BeworksBotIcon from '../../../components/BeworksBotIcon';
import { getServedByName } from '../utils/leadServedBy';
import { pillBaseSx, pillIconSx, pillTruncatedSx } from '../utils/leadPillStyles';

// Quem atende agora, em 3 estados: você (isAssignedToMe), um vendedor
// nomeado (getServedByName), ou o Agente Beworks (nenhum humano atribuído —
// mesmo tratamento visual de "sem atendente" do design, já que hoje isso
// sempre significa que a IA está atendendo).
const LeadServedByChip = ({ isAssignedToMe, assignedToName, lastAssignedToName, status }) => {
  const { t } = useTranslation();
  const servedByName = getServedByName({ assignedToName, lastAssignedToName, status });

  if (isAssignedToMe) {
    return (
      <Chip
        label={t('leads.servedByMe')}
        icon={<Person sx={{ ...pillIconSx, color: 'primary.main' }} />}
        size="small"
        sx={{ ...pillBaseSx, bgcolor: 'action.hover', color: 'text.primary' }}
      />
    );
  }

  if (servedByName) {
    return (
      <Tooltip title={servedByName}>
        <Chip
          label={servedByName}
          icon={<PersonOutlined sx={{ ...pillIconSx, color: 'inherit' }} />}
          size="small"
          sx={{ ...pillBaseSx, ...pillTruncatedSx, bgcolor: 'action.hover', color: 'text.primary' }}
        />
      </Tooltip>
    );
  }

  return (
    <Chip
      label={t('leads.servedByAgent')}
      icon={<BeworksBotIcon sx={{ ...pillIconSx, color: 'inherit' }} />}
      size="small"
      sx={{
        ...pillBaseSx,
        bgcolor: 'transparent',
        color: 'text.secondary',
        border: '1px dashed',
        borderColor: 'divider',
      }}
    />
  );
};

export default LeadServedByChip;
